import { Component, OnInit } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { gapFormUrl } from '../../../../shared/form-url';

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss'],
})
export class BenefitsComponent implements OnInit {
  typeOfPolicy = 'invoice';
  /** Which YouTube embed is mounted (facade until user clicks play). */
  activeVideo: string | null = null;
  readonly formUrl = gapFormUrl;

  constructor() {}

  ngOnInit(): void {}

  selectTypeOfPolicy(type: string): void {
    this.typeOfPolicy = type;
    this.activeVideo = null;
  }

  startVideo(type: string): void {
    this.activeVideo = type;
  }

  scrollToCalculator(event?: Event): void {
    event?.preventDefault();
    const element = document.getElementById('home__left');
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 50;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }

  hideOverlayPanel(overlayPanel: OverlayPanel): void {
    if (overlayPanel) {
      overlayPanel.hide();
    }
  }
}
